import type { GENERAL_SLIDE_DATA, GENERAL_SLIDE_PARAMS } from './types'

export const DEFAULT_GENERAL_SLIDE_DATA = (): GENERAL_SLIDE_DATA => ({
  type: 'general-slide',
  data: {
    button: null,
    image: null,
    pendingImage: null,
    title: null,
    perex: null,
  },
})

export const DEFAULT_GENERAL_SLIDE_PARAMS = (): GENERAL_SLIDE_PARAMS => ({
  color: null,
})
